import { Ref } from 'react'
import { Typography as AntdTypography } from 'antd'
import type { LinkProps as AntdLinkProps } from 'antd/lib/typography/Link'
import { makeBaseTextComponent } from './BaseText'
import type { BaseTextProps } from './BaseText'

export interface LinkProps extends AntdLinkProps, BaseTextProps {
  ref?: Ref<HTMLElement>
}

export const Link = (props: LinkProps) => {
  return <AntdTypographyLink {...props} />
}

const AntdTypographyLink = makeBaseTextComponent(AntdTypography.Link)
